'use client';

import { c as _c } from "react/compiler-runtime";
import useEmblaCarousel from 'embla-carousel-react';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
const OVERFLOW_TOLERANCE = 1;
interface UseThumbnailCarouselOptions {
  featureCount: number;
  selectedIndex: number;
}
export const useThumbnailCarousel = t0 => {
  const $ = _c(15);
  const {
    featureCount,
    selectedIndex
  } = t0;
  const [overflows, setOverflows] = useState(false);
  const overflowsRef = useRef(false);
  let t1;
  if ($[0] !== overflows) {
    t1 = {
      loop: false,
      align: "center",
      containScroll: "keepSnaps",
      dragFree: true,
      duration: 32,
      watchDrag: overflows
    };
    $[0] = overflows;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  let t2;
  let t3;
  if ($[2] !== emblaApi || $[3] !== overflows || $[4] !== selectedIndex) {
    t2 = () => {
      if (!overflows) {
        return;
      }
      emblaApi?.scrollTo(selectedIndex);
    };
    t3 = [emblaApi, overflows, selectedIndex];
    $[2] = emblaApi;
    $[3] = overflows;
    $[4] = selectedIndex;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== emblaApi) {
    t4 = () => {
      if (!emblaApi) {
        return;
      }
      let syncFrame = null;
      const syncOverflow = () => {
        syncFrame = null;
        const rootNode = emblaApi.rootNode();
        const containerNode = emblaApi.containerNode();
        const slides = Array.from(containerNode.children);
        const styles = window.getComputedStyle(containerNode);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const contentWidth = slides.reduce(_temp, 0) + Math.max(0, slides.length - 1) * gap;
        const nextOverflows = contentWidth > rootNode.clientWidth + OVERFLOW_TOLERANCE;
        if (overflowsRef.current === nextOverflows) {
          return;
        }
        overflowsRef.current = nextOverflows;
        setOverflows(nextOverflows);
      };
      const scheduleSync = () => {
        if (syncFrame !== null) {
          cancelAnimationFrame(syncFrame);
        }
        syncFrame = requestAnimationFrame(syncOverflow);
      };
      syncOverflow();
      window.addEventListener("resize", scheduleSync);
      const resizeObserver = typeof ResizeObserver !== "undefined" ? new ResizeObserver(scheduleSync) : null;
      resizeObserver?.observe(emblaApi.rootNode());
      resizeObserver?.observe(emblaApi.containerNode());
      emblaApi.slideNodes().forEach(slide_0 => resizeObserver?.observe(slide_0));
      return () => {
        if (syncFrame !== null) {
          cancelAnimationFrame(syncFrame);
        }
        window.removeEventListener("resize", scheduleSync);
        resizeObserver?.disconnect();
      };
    };
    $[7] = emblaApi;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== emblaApi || $[10] !== featureCount) {
    t5 = [emblaApi, featureCount];
    $[9] = emblaApi;
    $[10] = featureCount;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  useLayoutEffect(t4, t5);
  let t6;
  if ($[12] !== emblaRef || $[13] !== overflows) {
    t6 = {
      emblaRef,
      overflows
    };
    $[12] = emblaRef;
    $[13] = overflows;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp(total, slide) {
  return total + slide.getBoundingClientRect().width;
}